import React, { useState } from 'react';
import AdminDashboard from './AdminDashboard';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';
import { ADMIN_CONFIG } from '../../config/adminConfig';

const { LuLock, LuArrowLeft } = LuIcons;

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === ADMIN_CONFIG.adminPassword) {
      onLogin(true);
    } else {
      setError(true);
      setTimeout(() => setError(false), 3000);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-white p-8 rounded-3xl shadow-lg border border-slate-100 max-w-md w-full">
        <div className="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
          <SafeIcon icon={LuLock} className="h-8 w-8 text-slate-600" />
        </div>
        <h2 className="text-2xl font-bold text-center text-slate-900 mb-2">تسجيل الدخول للإدارة</h2>
        <p className="text-center text-slate-500 mb-8">الرجاء إدخال كلمة المرور للوصول إلى لوحة التحكم</p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">كلمة المرور</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={`w-full px-4 py-3 rounded-xl border ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-200 focus:ring-slate-900'} focus:outline-none focus:ring-2 transition-colors text-left`} placeholder="••••••••" dir="ltr" autoFocus />
            {error && <p className="mt-2 text-sm text-red-500">كلمة المرور غير صحيحة</p>}
          </div>
          <button type="submit" className="w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 transition-colors">
            دخول <SafeIcon icon={LuArrowLeft} className="ms-2 h-4 w-4" />
          </button>
        </form>
      </motion.div>
    </div>
  );
};

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem('admin_auth') === 'true' || sessionStorage.getItem('admin_auth') === 'true');

  // تفعيل وضع "تطبيق" على الهاتف: حقن manifest خاص بلوحة الإدارة فقط
  React.useEffect(() => {
    if (document.querySelector('link[rel="manifest"]')) return;
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = '/admin-manifest.webmanifest';
    document.head.appendChild(link);
    return () => link.remove();
  }, []);

  const handleLogin = (val) => { localStorage.setItem('admin_auth', 'true'); setIsAuthenticated(val); };
  const handleLogout = () => { localStorage.removeItem('admin_auth'); sessionStorage.removeItem('admin_auth'); setIsAuthenticated(false); };
  return <>{!isAuthenticated ? <AdminLogin onLogin={handleLogin} /> : <AdminDashboard onLogout={handleLogout} />}</>;
};

export default Admin;